import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Divider
} from '@mui/material';
import Heading from '../../Components/Heading/heading.tsx';

interface EditTripModalProps {
  open: boolean;
  onClose: () => void;
  trip: any | null;
  onSave: (payload: {
    odometer_start: number;
    odometer_end: number;
    orders_picked: number;
    orders_delivered: number;
  }) => void;
}

const EditTripModal: React.FC<EditTripModalProps> = ({
  open,
  onClose,
  trip,
  onSave
}) => {
  const [odometerStart, setOdometerStart] = useState('');
  const [odometerEnd, setOdometerEnd] = useState('');
  const [ordersPicked, setOrdersPicked] = useState('');
  const [ordersDelivered, setOrdersDelivered] = useState('');

  const [errors, setErrors] = useState({
    odometerStart: '',
    odometerEnd: '',
    ordersPicked: '',
    ordersDelivered: ''
  });

  useEffect(() => {
    if (trip) {
      setOdometerStart(String(trip.odometer_start ?? ''));
      setOdometerEnd(String(trip.odometer_end ?? ''));
      setOrdersPicked(String(trip.orders_picked ?? 0));
      setOrdersDelivered(String(trip.orders_delivered ?? 0));
      setErrors({
        odometerStart: '',
        odometerEnd: '',
        ordersPicked: '',
        ordersDelivered: ''
      });
    }
  }, [trip]);

  const validateOdometer = () => {
    const start = Number(odometerStart);
    const end = Number(odometerEnd);
    
    if (isNaN(start) || isNaN(end)) return;
    console.log(start,end)
    if (start > end) {
      setErrors(prev => ({
        ...prev,
        odometerStart: 'Odometer Start cannot be greater than Odometer End',
        odometerEnd: 'Odometer End cannot be less than Odometer Start'
      }));
    } else {
      setErrors(prev => ({
        ...prev,
        odometerStart: '',
        odometerEnd: ''
      }));
    }
  };

  const validateOrders = () => {
    const picked = Number(ordersPicked);
    const delivered = Number(ordersDelivered);
    
    if (isNaN(picked) || isNaN(delivered)) return;
    
    if (delivered > picked) {
      setErrors(prev => ({
        ...prev,
        ordersPicked: 'Orders Picked cannot be less than Orders Delivered',
        ordersDelivered: 'Orders Delivered cannot be greater than Orders Picked'
      }));
    } else {
      setErrors(prev => ({
        ...prev,
        ordersPicked: '',
        ordersDelivered: ''
      }));
    }
  };

  const handleSave = () => {
    validateOdometer();
    validateOrders();

    const hasErrors = Object.values(errors).some(error => error !== '');
    const odometerInvalid = Number(odometerStart) > Number(odometerEnd);
    const ordersInvalid = Number(ordersDelivered) > Number(ordersPicked);
    
    if (hasErrors || odometerInvalid || ordersInvalid) {
      if (odometerInvalid && !errors.odometerStart) {
        validateOdometer();
      }
      if (ordersInvalid && !errors.ordersDelivered) {
        validateOrders();
      }
      return;
    }

    onSave({
      odometer_start: Number(odometerStart),
      odometer_end: Number(odometerEnd),
      orders_picked: Number(ordersPicked),
      orders_delivered: Number(ordersDelivered),
    });
  };

  if (!trip) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
     
         <Box
                sx={{
                  marginLeft: {
                    xs: '0px',
                    sm: '-180px',
                  },
                }}
              > 
          <Heading title="Edit Trip Details" closeIcon="true" onClose={onClose} />
        </Box>

         <DialogContent>

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Odometer Start"
            type="number"
            value={odometerStart}
            onChange={(e) => {
              setOdometerStart(e.target.value);
              setErrors(prev => ({ ...prev, odometerStart: '' }));
            }}
            onBlur={validateOdometer}
            error={!!errors.odometerStart}
            helperText={errors.odometerStart}
            fullWidth
          />

          <TextField
            label="Odometer End"
            type="number"
            value={odometerEnd}
            onChange={(e) => {
              setOdometerEnd(e.target.value);
              setErrors(prev => ({ ...prev, odometerEnd: '' }));
            }}
            onBlur={validateOdometer}
            error={!!errors.odometerEnd}
            helperText={errors.odometerEnd}
            fullWidth
          />

          <TextField
            label="Orders Picked"
            type="number"
            value={ordersPicked}
            onChange={(e) => {
              setOrdersPicked(e.target.value);
              setErrors(prev => ({ ...prev, ordersPicked: '' }));
            }}
            onBlur={validateOrders}
            error={!!errors.ordersPicked}
            helperText={errors.ordersPicked}
            fullWidth
          />

          <TextField
            label="Orders Delivered"
            type="number"
            value={ordersDelivered}
            onChange={(e) => {
              setOrdersDelivered(e.target.value);
              setErrors(prev => ({ ...prev, ordersDelivered: '' }));
            }}
            onBlur={validateOrders}
            error={!!errors.ordersDelivered}
            helperText={errors.ordersDelivered}
            fullWidth
          />
        </Box>
      </DialogContent>

      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={onClose} variant="outlined" className="custom-cancel-button">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained"  className="custom-button">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditTripModal;